export class Category {
  icon: string = "";
  id: number;
  name: string = "Category 1";
  desc: string = "Top level category";
  editme: boolean = false;
  html: string='';
  subcategories: Category[];
  forceWide: boolean;
  lowerBack: false;
  thinTopCard: false;
  subcategoryForceWide: boolean = false;
  xyz: boolean = false;
  largeMenu: boolean;
  link: any;



  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}




// WEBPACK FOOTER //
// ./src/app/category/category.ts